// week-start.ts

// 1. Extend the Intl.Locale interface to include weekInfo
declare global {
    interface LocaleWeekInfo {
        firstDay: number;
    }
    interface Intl {
        Locale: {
            prototype: {
                readonly weekInfo: LocaleWeekInfo;
            };
        };
    }
}

// 2. Tiny CLDR-based lookup table
const firstDayOfWeekMap: Record<string, number> = {
    // Sunday-start
    US: 0,
    CA: 0,
    GB: 0,
    AU: 0,
    NZ: 0,
    JP: 0,
    // Monday-start
    AT: 1,
    BE: 1,
    CH: 1,
    DE: 1,
    DK: 1,
    ES: 1,
    FI: 1,
    FR: 1,
    NL: 1,
    NO: 1,
    PT: 1,
    RU: 1,
    SE: 1,
    TR: 1,
    CN: 1,
    IN: 1,
    // Saturday-start
    AE: 6,
    AF: 6,
    BH: 6,
    DJ: 6,
    DZ: 6,
    EG: 6,
    IQ: 6,
    IR: 6,
    JO: 6,
    KW: 6,
    LY: 6,
    MA: 6,
    OM: 6,
    QA: 6,
    SA: 6,
    SD: 6,
    SY: 6,
    YE: 6,
    // fallback
    default: 1,
};

// 3. Extract region subtag and look up first-day index
function lookupFirstDay(localeStr: string): number {
    const parts = localeStr.replace(/_/g, '-').split('-');
    const maybeRegion = parts[1]?.toUpperCase();
    const isRegion = maybeRegion && (/^[A-Z]{2}$/.test(maybeRegion) || /^\d{3}$/.test(maybeRegion));
    if (isRegion && firstDayOfWeekMap[maybeRegion!] != null) {
        return firstDayOfWeekMap[maybeRegion!];
    }
    return firstDayOfWeekMap.default;
}

// 4. Polyfill if needed
(function polyfillWeekInfo() {
    if (
        typeof Intl === 'object' &&
        typeof Intl.Locale === 'function' &&
        !('weekInfo' in Intl.Locale.prototype)
    ) {
        Object.defineProperty(Intl.Locale.prototype, 'weekInfo', {
            get(): { firstDay: number } {
                // baseName is ES2022; fallback to toString()
                const tag = (this as any).baseName ?? this.toString();
                return { firstDay: lookupFirstDay(tag) };
            },
            configurable: true,
            enumerable: false,
        });
    }
})();

export {}; // ensure this file is a module so the `declare global` sticks
